module.exports = __webpack_public_path__ + "static/media/material_preparacion.ad69b603.png";